import React from 'react'

type UseImageReturnType =
  | {
      loading: true
      error: undefined
      image: undefined
    }
  | {
      loading: false
      error: unknown
      image?: undefined
    }
  | {
      loading: false
      error?: undefined
      image: string
    }

const initialState: UseImageReturnType = {
  loading: true,
  error: undefined,
  image: undefined,
}

export const useImage = (fileName: string, additionalState: string): UseImageReturnType => {
  const [state, setState] = React.useState<UseImageReturnType>(initialState)

  React.useEffect(() => {
    setState(initialState)

    const fetchImage = async () => {
      try {
        const response = await import(`./${additionalState}/${fileName}.png`)
        setState({ loading: false, image: response.default })
      } catch (error) {
        setState({ loading: false, error })
      }
    }

    fetchImage()
  }, [fileName, additionalState])

  return state
}
